// La fenêtre Gym'Coach de l'app (plein écran, thème sombre), reproduite à ses
// dimensions réelles (390 points) puis réduite dans le téléphone. Disposition,
// tailles et couleurs reprises de components/GymCoachModal.js ; textes au
// format de l'API (Parametrage/CoachRegles/Redaction.cs).
//
// Le coach a retouché une série : bandeau « Personnalisée par ton coach »,
// ligne orange marquée COACH, et pas de « Recalculer » pour l'élève.
import React from "react";
import Apercu from "./Apercu";
import Tiggy from "../Tiggy";

const ORANGE = "#F87B1B";

const Personne = ({ t = 11 }) => (
	<svg width={t} height={t} viewBox="0 0 24 24" fill={ORANGE} aria-hidden="true">
		<circle cx="12" cy="8" r="4" />
		<path d="M4 20c0-4 3.6-6 8-6s8 2 8 6z" />
	</svg>
);

const MarqueCoach = () => (
	<span className="gs-gc-marque">
		<Personne />
		COACH
	</span>
);

function Objectif({ i, numero, reps, charge, rpe, coach = false, avant, texte }) {
	return (
		<div className="gs-gc-serie gs-a-etape" style={{ "--i": i }}>
			<div className="gs-gc-ligne-marque">
				<span className="gs-gc-libelle">Objectif série {numero}</span>
				{coach && <MarqueCoach />}
			</div>
			<div className={`gs-gc-pastille${coach ? " gs-gc-pastille--coach" : ""}`}>
				<span className="gs-gc-reps">{reps}</span>
				<span className="gs-gc-charge"> × {charge} kg</span>
				{rpe && <span className="gs-gc-rpe">RPE {rpe}</span>}
			</div>
			{avant && <div className="gs-gc-avant">avant {avant}</div>}
			{texte && <div className="gs-gc-justif">{texte}</div>}
		</div>
	);
}

export default function ApercuFicheGymCoach({ className = "" }) {
	return (
		<Apercu
			className={className}
			description="Fenêtre Gym'Coach de l'app pour la séance « Pull » : un résumé, puis un objectif par série du tirage horizontal, dont la série 2 fixée par le coach, et le bouton « Préremplir la séance »."
		>
			<div className="gs-tel gs-tel--app">
				<div className="gs-tel-ecran gs-tel-ecran--app">
					<span className="gs-tel-encoche" />
					<div className="gs-app gs-gc">
						<div className="gs-gc-entete">
							<Tiggy pose="ordinateur" taille={44} className="gs-gc-tiggy" />
							<div className="gs-gc-bloc-titre">
								<div className="gs-gc-titre">Gym'Coach</div>
								<div className="gs-gc-sous-titre">Ta séance, série par série</div>
							</div>
							<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#e3e7f9" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
								<path d="M6 6l12 12M18 6L6 18" />
							</svg>
						</div>
						<div className="gs-gc-separateur" />

						<div className="gs-gc-corps">
							<div className="gs-gc-bandeau gs-a-etape" style={{ "--i": 0 }}>
								<Personne t={18} />
								<span>Personnalisée par ton coach</span>
							</div>

							<div className="gs-gc-resume gs-a-etape" style={{ "--i": 1 }}>
								<div className="gs-gc-resume-titre">3 exercices : 2 en progression, 1 stable.</div>
								<div className="gs-gc-resume-detail">Tu as fait cette séance pour la dernière fois il y a 4 jours.</div>
							</div>

							<div className="gs-gc-bloc gs-a-etape" style={{ "--i": 2 }}>
								<div className="gs-gc-entete-exo">
									<span className="gs-gc-rail" />
									<span className="gs-gc-nom-exo">Tirage horizontal</span>
								</div>
								<div className="gs-gc-texte-exo">En progression : 1RM estimé de 100,5 à 104,2 kg sur 4 séances.</div>
								<Objectif
									i={3}
									numero={1}
									reps="8"
									charge="82,5"
									rpe="8"
									avant="8 × 80 kg"
									texte="Tu as tenu 8 reps à 80 kg : c'est le moment de charger."
								/>
								<Objectif i={4} numero={2} reps="8" charge="80" rpe="8,5" coach avant="8 × 80 kg" texte="Deux reps en réserve." />
								<Objectif
									i={5}
									numero={3}
									reps="7"
									charge="80"
									avant="6 × 80 kg"
									texte="Tu as tenu 6 reps à 80 kg sur cette série la dernière fois."
								/>
							</div>

							<div className="gs-gc-horodatage">Calculée le 07/10 à 07:42</div>
							<div className="gs-gc-bouton gs-a-etape" style={{ "--i": 6 }}>
								<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#141417" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
									<path d="M12 4v11M7 10l5 5 5-5M5 20h14" />
								</svg>
								Préremplir la séance
							</div>
						</div>
					</div>
				</div>
			</div>
		</Apercu>
	);
}
